import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import store from "@/store";

export var msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_AD_CLIENT_ID,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: process.env.VUE_APP_AD_REDIRECT_URI,
        authority: process.env.VUE_APP_AD_AUTHORITY
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    },
    system: {
        loggerOptions: {
            loggerCallback: function (level, message, containsPii) {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: LogLevel.Verbose
        }
    }
};
export var msalInstance = new PublicClientApplication(msalConfig);
// Add here scopes for id token to be used at MS Identity Platform endpoints.
export var loginRequest = {
    scopes: ['User.ReadWrite', 'Profile', 'offline_access'],
    tokenRequest: [process.env.VUE_APP_API_SCOPES]
};

// Add here the endpoints for MS Graph API services you would like to use.
export var graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
//# sourceMappingURL=authConfig.js.map